import common from './common.json'
import objectives from './objectives.json'
import home from './home.json'
import menu from './menu.json'
import devTools from './devTools.json'
import devToolsNew from './devToolsNew.json'
import carbonOffsetConfiguration from './carbonOffsetConfiguration.json'
import assistanceConfiguration from './assistanceConfiguration.json'
import monConseillerPersoConfiguration from './monConseillerPersoConfiguration.json'
import additionalSales from './additionalSales.json'
import subscriptionTable from './subscriptionTable.json'
import subscriptionForm from './subscriptionForm.json'
import subscriptionTools from './subscriptionTools.json'
import servicesManagement from './admin/servicesManagement.json'
import organizationManagement from './admin/organizationManagement.json'
import providerOptionsManagement from './admin/providerOptionsManagement.json'
import officesManagement from './admin/officesManagement.json'
import usersManagement from './admin/usersManagement.json'
import teamsManagement from './admin/teamsManagement.json'
import websalesUsersManagement from './admin/websalesUsersManagement.json'
import ipAddressesManagement from './admin/ipAddressesManagement.json'
import additionalProductsManagement from './admin/additionalProductsManagement.json'
import auth from './auth.json'
import dashboard from './dashboard.json'
import contractsTable from './contractsTable.json'

export default {
  home,
  objectives,
  common,
  menu,
  devTools,
  devToolsNew,
  carbonOffsetConfiguration,
  additionalSales,
  subscriptionTable,
  subscriptionForm,
  subscriptionTools,
  servicesManagement,
  organizationManagement,
  providerOptionsManagement,
  usersManagement,
  teamsManagement,
  websalesUsersManagement,
  ipAddressesManagement,
  additionalProductsManagement,
  auth,
  dashboard,
  assistanceConfiguration,
  monConseillerPersoConfiguration,
  officesManagement,
  contractsTable,
}
